import { HttpStatus as t } from "@hprofits/utils";
import { oc as i } from "@orpc/contract";
import { oo as e } from "@orpc/openapi";
import { authSecurity as r } from "../../swagger/security.js";
import "../../swagger/tags.js";
import { authMeta as s } from "./procedure-meta.js";
const f = () => i.meta(s.public()), D = (o) => o?.length ? i.meta(s.requirePrivileges(...o)).errors({
  UNAUTHORIZED: e.spec(
    { status: t.UNAUTHORIZED, message: "Authentication required" },
    { security: r }
  ),
  FORBIDDEN: e.spec(
    { status: t.FORBIDDEN, message: "Insufficient privileges" },
    { security: r }
  )
}) : i.meta(s.authenticated()).errors({
  UNAUTHORIZED: e.spec(
    { status: t.UNAUTHORIZED, message: "Authentication required" },
    { security: r }
  )
});
export {
  D as ocPrivate,
  f as ocPublic
};
//# sourceMappingURL=procedure-builders.js.map
